(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.beverageCans = {
    attach: function(context, settings) {

      // Set a class on the related field for the currently selected system of measurement
      const setMeasurementClass = function($input) {
        const $field = $input.closest('.block-content').find('.field--name-field-pbc-specs');
        $field.removeClass('system-metric');
        $field.removeClass('system-imperial');
        $field.addClass('system-' + $input.val());
      };

      // Update the class when the value changes
      jQuery('.specs-measurement-toggle input[name="measurement-system"]').unbind().change(function(e) {
        const $input = jQuery(this);
        setMeasurementClass($input);
      });

      // Allow a click on the slider to change the value
      jQuery('.specs-measurement-toggle .toggle-slider').unbind().click(function(e) {
        const $uncheckedInput = jQuery('input[name="measurement-system"]').not(':checked');
        $uncheckedInput.prop('checked', true);
        setMeasurementClass($uncheckedInput);
      });

      jQuery('.specs-measurement-toggle .label').unbind().on('keypress', function(e) {
        const $label = jQuery(this);

        if (e.which === 13) {
          $label.click();
        }
      });

      //* Removes Unit text from labels (visually)
      jQuery('.paragraph--type--specs .field__label').each(function() {
        const $label = jQuery(this);
        if ($label.find('.unit').length === 0) {
          $label.html(function(_, html) {
            return html.replace(/(\s*Metric|Imperial\s*)/g, '<span class="sr-only unit">$1</span>');
          });
        }
      });
    }
  };

})(jQuery, Drupal);
